export default "__VITE_ASSET__C14M5gIF__"